// Enhanced Philippine fault line data with more accurate coordinates
export const philippineFaultLines = [
  // Philippine Fault Zone - Northern Segment (Luzon)
  {
    id: 'philippine-fault-northern',
    name: 'Philippine Fault Zone - Northern Luzon',
    type: 'strike-slip',
    coordinates: [
      [18.5, 120.0], [18.0, 120.2], [17.5, 120.4], [17.0, 120.6],
      [16.5, 120.8], [16.0, 121.0], [15.5, 121.2], [15.0, 121.4],
      [14.5, 121.6], [14.0, 121.8], [13.5, 122.0]
    ],
    color: '#dc2626',
    weight: 3,
    opacity: 0.8,
    description: 'Major strike-slip fault system running through Northern Luzon (Ilocos to Nueva Ecija)'
  },
  
  // Philippine Fault Zone - Central Luzon Segment
  {
    id: 'philippine-fault-central-luzon',
    name: 'Philippine Fault Zone - Central Luzon',
    type: 'strike-slip',
    coordinates: [
      [13.5, 122.0], [13.0, 122.2], [12.5, 122.4], [12.0, 122.6],
      [11.5, 122.8], [11.0, 123.0]
    ],
    color: '#dc2626',
    weight: 3,
    opacity: 0.8,
    description: 'Major strike-slip fault system running through Central Luzon (Aurora to Quezon)'
  },
  
  // Philippine Fault Zone - Eastern Visayas
  {
    id: 'philippine-fault-visayas',
    name: 'Philippine Fault Zone - Visayas Segment',
    type: 'strike-slip',
    coordinates: [
      [11.0, 123.0], [10.8, 123.2], [10.6, 123.4], [10.4, 123.6],
      [10.2, 123.8], [10.0, 124.0], [9.8, 124.2], [9.6, 124.4],
      [9.4, 124.6], [9.2, 124.8]
    ],
    color: '#dc2626',
    weight: 3,
    opacity: 0.8,
    description: 'Major strike-slip fault system running through the Visayas (Masbate and Leyte)'
  },
  
  // Philippine Fault Zone - Mindanao Segment
  {
    id: 'philippine-fault-mindanao',
    name: 'Philippine Fault Zone - Mindanao Segment',
    type: 'strike-slip',
    coordinates: [
      [9.2, 124.8], [9.0, 125.0], [8.8, 125.2], [8.6, 125.4],
      [8.4, 125.6], [8.2, 125.8], [8.0, 126.0], [7.8, 126.2],
      [7.6, 126.4], [7.4, 126.6], [7.2, 126.8], [7.0, 127.0]
    ],
    color: '#dc2626',
    weight: 3,
    opacity: 0.8,
    description: 'Major strike-slip fault system running through Mindanao (Agusan to Davao)'
  },
  
  // West Valley Fault System (Metro Manila)
  {
    id: 'west-valley-fault',
    name: 'West Valley Fault System',
    type: 'strike-slip',
    coordinates: [
      [14.2, 121.0], [14.3, 121.05], [14.4, 121.1], [14.5, 121.15],
      [14.6, 121.2], [14.7, 121.25], [14.8, 121.3]
    ],
    color: '#ea580c',
    weight: 2.5,
    opacity: 0.7,
    description: 'Active fault capable of generating major earthquakes near Metro Manila'
  },
  
  // East Valley Fault System (Metro Manila)
  {
    id: 'east-valley-fault',
    name: 'East Valley Fault System',
    type: 'strike-slip',
    coordinates: [
      [14.2, 121.2], [14.3, 121.25], [14.4, 121.3], [14.5, 121.35],
      [14.6, 121.4], [14.7, 121.45], [14.8, 121.5]
    ],
    color: '#ea580c',
    weight: 2.5,
    opacity: 0.7,
    description: 'Active fault system east of Metro Manila'
  },
  
  // Digdig Fault (Luzon)
  {
    id: 'digdig-fault',
    name: 'Digdig Fault',
    type: 'strike-slip',
    coordinates: [
      [16.0, 120.5], [16.2, 120.4], [16.4, 120.3], [16.6, 120.2]
    ],
    color: '#ea580c',
    weight: 2,
    opacity: 0.7,
    description: 'Active fault in northern Luzon'
  },
  
  // Guinayangan Fault (Luzon)
  {
    id: 'guinayangan-fault',
    name: 'Guinayangan Fault',
    type: 'strike-slip',
    coordinates: [
      [15.5, 121.0], [15.7, 120.9], [15.9, 120.8], [16.1, 120.7]
    ],
    color: '#ea580c',
    weight: 2,
    opacity: 0.7,
    description: 'Active fault in central Luzon'
  },
  
  // Philippine Trench
  {
    id: 'philippine-trench',
    name: 'Philippine Trench',
    type: 'subduction',
    coordinates: [
      [19.0, 124.5], [17.5, 125.0], [16.0, 125.5], [14.5, 126.0],
      [13.0, 126.5], [11.5, 127.0], [10.0, 127.5], [8.5, 128.0],
      [7.0, 128.5], [5.5, 129.0]
    ],
    color: '#2563eb',
    weight: 3,
    opacity: 0.8,
    description: 'Major subduction zone where oceanic plate dives beneath the Philippine Sea Plate'
  },
  
  // Manila Trench
  {
    id: 'manila-trench',
    name: 'Manila Trench',
    type: 'subduction',
    coordinates: [
      [18.5, 119.5], [17.0, 119.0], [15.5, 118.5], [14.0, 118.0],
      [12.5, 117.5], [11.0, 117.0]
    ],
    color: '#2563eb',
    weight: 3,
    opacity: 0.8,
    description: 'Subduction zone west of Luzon, capable of generating mega-earthquakes'
  },
  
  // Negros Trench
  {
    id: 'negros-trench',
    name: 'Negros Trench',
    type: 'subduction',
    coordinates: [
      [11.5, 122.5], [10.5, 122.0], [9.5, 121.5], [8.5, 121.0]
    ],
    color: '#2563eb',
    weight: 2.5,
    opacity: 0.7,
    description: 'Subduction zone near Negros Island'
  },
  
  // Sulu Trench
  {
    id: 'sulu-trench',
    name: 'Sulu Trench',
    type: 'subduction',
    coordinates: [
      [10.0, 120.0], [9.0, 119.5], [8.0, 119.0], [7.0, 118.5],
      [6.0, 118.0], [5.0, 117.5]
    ],
    color: '#2563eb',
    weight: 2.5,
    opacity: 0.7,
    description: 'Subduction zone in the Sulu Sea'
  },
  
  // Cotabato Trench
  {
    id: 'cotabato-trench',
    name: 'Cotabato Trench',
    type: 'subduction',
    coordinates: [
      [8.0, 124.0], [7.0, 123.5], [6.0, 123.0], [5.0, 122.5]
    ],
    color: '#2563eb',
    weight: 2.5,
    opacity: 0.7,
    description: 'Subduction zone in Mindanao region'
  },
  
  // Central Leyte Fault
  {
    id: 'central-leyte-fault',
    name: 'Central Leyte Fault',
    type: 'strike-slip',
    coordinates: [
      [11.2, 124.8], [10.8, 124.9], [10.4, 125.0], [10.0, 125.1]
    ],
    color: '#ea580c',
    weight: 2,
    opacity: 0.7,
    description: 'Active fault in Leyte Island'
  },
  
  // Mindanao Fault
  {
    id: 'mindanao-fault',
    name: 'Mindanao Fault',
    type: 'strike-slip',
    coordinates: [
      [8.5, 125.0], [8.0, 125.2], [7.5, 125.4], [7.0, 125.6],
      [6.5, 125.8], [6.0, 126.0]
    ],
    color: '#dc2626',
    weight: 2,
    opacity: 0.7,
    description: 'Major fault system in Mindanao'
  },
  
  // Samar Fault
  {
    id: 'samar-fault',
    name: 'Samar Fault',
    type: 'strike-slip',
    coordinates: [
      [12.5, 124.5], [12.0, 124.8], [11.5, 125.1], [11.0, 125.4]
    ],
    color: '#ea580c',
    weight: 2,
    opacity: 0.7,
    description: 'Active fault in Samar Island'
  },
  
  // Lubang Fault (Offshore)
  {
    id: 'lubang-fault',
    name: 'Lubang Fault',
    type: 'strike-slip',
    coordinates: [
      [13.8, 120.0], [13.9, 120.1], [14.0, 120.2], [14.1, 120.3]
    ],
    color: '#ea580c',
    weight: 2,
    opacity: 0.7,
    description: 'Offshore fault near Lubang Island'
  },
  
  // Ragay Gulf Fault
  {
    id: 'ragay-gulf-fault',
    name: 'Ragay Gulf Fault',
    type: 'normal',
    coordinates: [
      [13.5, 123.0], [13.4, 123.1], [13.3, 123.2], [13.2, 123.3]
    ],
    color: '#f59e0b',
    weight: 1.5,
    opacity: 0.6,
    description: 'Normal fault in Ragay Gulf area'
  }
];

// Helper function to get fault line style
export const getFaultLineStyle = (fault) => ({
  color: fault.color,
  weight: fault.weight,
  opacity: fault.opacity,
  dashArray: fault.type === 'subduction' ? '10,5' : null,
  dashOffset: null
});

// Helper function to create popup content for fault lines
export const createFaultPopupContent = (fault) => `
  <div class="p-2 min-w-[200px]">
    <div class="font-semibold text-lg mb-2" style="color: ${fault.color}">
      ${fault.name}
    </div>
    <div class="space-y-1 text-sm">
      <div><strong>Type:</strong> ${fault.type.replace('-', ' ')}</div>
      <div><strong>Description:</strong> ${fault.description}</div>
    </div>
  </div>
`;